import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type HttpError = Extract<FetchBaseQueryError, { status: number }>;

export function isHttpError(error: unknown): error is HttpError {
  return typeof error === 'object' && error !== null && typeof (error as { status?: unknown }).status === 'number';
}

export function getErrorCode(error: HttpError): string | undefined {
  const errorCode = (error.data as { errorCode?: unknown } | null)?.errorCode;
  return typeof errorCode === 'string' ? errorCode : undefined;
}
